/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classnames as cx } from '@ba-ui-toolkit/utils';
import styles from './ColorRangeScale.scss';
// import RangeSlider from '../slider/RangeSlider';

const colorrangescaleClassName = styles.colorrangescaleClassName.replace(/"/g, '');

export default class ColorRangeScale extends Component {
	static propTypes = {
		/** Additionnal classNames */
		className: PropTypes.string,
		/** The min value of the scale (not required) */
		minValue: PropTypes.number,
		/** The max value of the scale (not required) */
		maxValue: PropTypes.number,
		/** The steps and colors */
		steps: PropTypes.array.isRequired,
		/** Are sliders displayed */
		sliders: PropTypes.bool,
		/** Custom Styles */
		style: PropTypes.object,
		/** Custom onClick method when clicking on a colour */
		onClick: PropTypes.func,
	};

	static defaultProps = {
		className: '',
		minValue: 0,
		maxValue: 100,
		sliders: false,
		style: {},
	};

	constructor(props) {
		super(props);
		this.state = {
			selectedColor: null,
		};
		this._onClick = this._onClick.bind(this);
	}

	_onClick = swatch => {
		this.setState(
			{ selectedColor: swatch },
			this.props.onClick && this.props.onClick(this.state.selectedColor)
		);
	};

	render() {
		const { className, minValue, steps, sliders, style } = this.props;
		const { length } = steps;
		const ranges = [];

		for (let i = 0; i < steps.length; i++) {
			const swatch = steps[i].color;
			const selected = this.state.selectedColor === swatch;
			ranges.push(
				<div
					className={cx('color-range', { selected })}
					key={i}
					style={{ background: swatch, ...style }}
					onClick={() => this._onClick(swatch)}
				/>
			);
		}

		return (
			<div className={`${colorrangescaleClassName} ${className}`}>
				<div className={`${colorrangescaleClassName}__swatches`}>
					{ranges}
					{/* {steps.map((step, i) => (
                        <div className={cx('color-range', { selected })}
                            key={i}
                            style={{ background: step.color, ...style }}
                            onChange={this._onChange(step.color)} />
                    ))} */}
				</div>
				<div className={`${colorrangescaleClassName}__sliders`}>
					{sliders &&
						// steps.map((step, i) =>
						//     (<RangeSlider className={`range__${i}`}
						//         min={minValue}
						//         max={maxValue}
						//         showHandleLabel
						//         showBoundaryLabels
						//         showTooltip
						//         size='small'
						//         onChange={(i)=>this._rangeOnChange(i)}
						//     />))
						steps.map((step, i) => (
							<input
								key={i}
								type="range"
								min={minValue}
								max={step.breakpoint}
								className={`${step.breakpoint}`}
							/>
						))}
				</div>
				<div className={`${colorrangescaleClassName}__labels`}>
					{length > 0 && (
						<div key={-1} className="range-label" style={{ left: 0 }}>
							Min
						</div>
					)}
					{steps.map((step, i) => (
						<div
							key={i}
							className="range-label"
							style={{ left: `${((i + 1) * 100) / length}%` }}
						>
							{i === length - 1 ? 'Max' : step.breakpoint}
						</div>
					))}
				</div>
			</div>
		);
	}
}
